export default __webpack_public_path__ + "static/media/Agradut.496e7067.jpg";